export default __webpack_public_path__ + "static/char-t-21-ko-b6a8a706c9d8b11a859794ed772476a1.webp";